import ol_Map from 'ol/Map';
import ol_style_Style from 'ol/style/Style';
import ol_style_Circle from 'ol/style/Circle';
import ol_style_Fill from 'ol/style/Fill';
import ol_style_Stroke from 'ol/style/Stroke';
import ol_style_Text from 'ol/style/Text';
import ol_style_RegularShape from 'ol/style/RegularShape';
import * as olExtent from 'ol/extent';

export class ClusterStyle {
    constructor(vectorSource) {
        this.vectorStyleFunction = (feature, resolution) => {
            if (resolution != this.currentResolution) {
                this.calculateClusterInfo(resolution);
                this.currentResolution = resolution;
            }
            var style;
            var size = feature.get('features').length;
            if (size > 1) {
                style = new ol_style_Style({
                    image: new ol_style_Circle({
                        radius: feature.get('radius'),
                        fill: new ol_style_Fill({
                            color: [255, 153, 0, Math.min(0.8, 0.4 + (size / this.maxFeatureCount))]
                        })
                    }),
                    text: new ol_style_Text({
                        text: size.toString(),
                        fill: new ol_style_Fill({ color: '#fff' }),
                        stroke: new ol_style_Stroke({ color: 'rgba(0, 0, 0, 0.6)', width: 3 })
                    })
                });
            }
            else {
                var originalFeature = feature.get('features')[0];
                style = this.createClusterStyle(originalFeature);
            }
            return style;
        };
        this.selectStyleFunction = (feature) => {
            var invisibleFill = new ol_style_Fill({ color: 'rgba(255, 255, 255, 0.01)' });
            var styles = [new ol_style_Style({
                    image: new ol_style_Circle({
                        radius: feature.get('radius'),
                        fill: invisibleFill
                    })
                })];
            var originalFeatures = feature.get('features');
            var originalFeature;
            for (var i = originalFeatures.length - 1; i >= 0; --i) {
                originalFeature = originalFeatures[i];
                styles.push(this.createClusterStyle(originalFeature));
            }
            return styles;
        };
        this.source = vectorSource;
    }
    calculateClusterInfo(resolution) {
        this.maxFeatureCount = 0;
        var features = this.source.getFeatures();
        var feature, radius;
        for (var i = features.length - 1; i >= 0; --i) {
            feature = features[i];
            var originalFeatures = feature.get('features');
            var extent = olExtent.createEmpty();
            var j, jj;
            for (j = 0, jj = originalFeatures.length; j < jj; ++j) {
                olExtent.extend(extent, originalFeatures[j].getGeometry().getExtent());
            }
            this.maxFeatureCount = Math.max(this.maxFeatureCount, jj);
            radius = 0.25 * (olExtent.getWidth(extent) + olExtent.getHeight(extent)) /
                resolution;
            feature.set('radius', radius);
        }
    }
    createClusterStyle(feature) {
        var clusterFill = new ol_style_Fill({ color: 'rgba(255, 153, 0, 0.8)' });
        var clusterStroke = new ol_style_Stroke({ color: 'rgba(255, 204, 0, 0.2)', width: 1 });
        // 2012_Earthquakes_Mag5.kml stores the magnitude of each earthquake in a
        // standards-violating <magnitude> tag in each Placemark.  We extract it
        // from the Placemark's name instead.
        var name = feature.get('name');
        var magnitude = parseFloat(name.substr(2));
        var radius = 5 + 20 * (magnitude - 5);
        return new ol_style_Style({
            geometry: feature.getGeometry(),
            image: new ol_style_RegularShape({
                radius1: radius,
                radius2: 3,
                points: 5,
                angle: Math.PI,
                fill: clusterFill,
                stroke: clusterStroke
            })
        });
    }
}